import { render, staticRenderFns } from "./JobItem.vue?vue&type=template&id=9ba2f658&scoped=true"
import script from "./JobItem.vue?vue&type=script&lang=js"
export * from "./JobItem.vue?vue&type=script&lang=js"
import style0 from "./JobItem.vue?vue&type=style&index=0&id=9ba2f658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba2f658",
  null
  
)

export default component.exports